import script from "./colorcardDistributeAnalysis.vue?vue&type=script&setup=true&lang=js"
export * from "./colorcardDistributeAnalysis.vue?vue&type=script&setup=true&lang=js"

import "./colorcardDistributeAnalysis.vue?vue&type=style&index=0&id=00678067&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\86183\\Desktop\\yw-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00678067"]])

export default __exports__